import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers } from 'recompose'
import { googleAnalyticPromotionImpressions, googleAnalyticPromotionClicks } from 'actions/googleAnalytic'
import withType from 'components/common/hoc/withType'
import ScrollableBrandPromotionSpotlight from './ScrollableBrandPromotionSpotlight'
import { PROMO_CALL } from 'constant'

const withSendAnalyticOnDidMount = lifecycle({
  componentDidMount() {
    const { items, googleAnalyticPromotionImpressions } = this.props

    googleAnalyticPromotionImpressions({ items, creative: 'brand-details-offer' })
  }
})

const withPromotionClickHandler = withHandlers({
  handlePromotionClick: ({ googleAnalyticPromotionClicks }) => ({ event, item, index }) => {
    if (event.target.getAttribute('data-type') === PROMO_CALL) {
      googleAnalyticPromotionClicks({ item, index })
    }
  }
})

export default compose(
  withType({ type: 'ScrollableBrandPromotionSpotlight' }),
  connect(null, { googleAnalyticPromotionImpressions, googleAnalyticPromotionClicks }),
  withSendAnalyticOnDidMount,
  withPromotionClickHandler
)(ScrollableBrandPromotionSpotlight)
